import { render, staticRenderFns } from "./EditTransporter.vue?vue&type=template&id=255c4d9a&scoped=true&"
import script from "./EditTransporter.vue?vue&type=script&lang=js&"
export * from "./EditTransporter.vue?vue&type=script&lang=js&"
import style0 from "./EditTransporter.vue?vue&type=style&index=0&id=255c4d9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c4d9a",
  null
  
)

export default component.exports